import React from "react";
import Svg, { Path, SvgProps, Circle } from "react-native-svg";

const GraphIcon = (props: SvgProps) => {
  return (
    <Svg width="48" height="48" fill="none">
      <Circle cx="24" cy="24" r="24" fill="#FFF3C2" />
      <Path
        fill="#8C6500"
        d="M18.875 18.5a.936.936 0 1 0-1.875 0v9.844a2.343 2.343 0 0 0 2.344 2.343h11.718a.936.936 0 1 0 0-1.875H19.345a.47.47 0 0 1-.469-.468V18.5Zm11.912 2.537a.939.939 0 0 0-1.327-1.327l-3.085 3.088-1.682-1.682a.939.939 0 0 0-1.327 0l-3.281 3.282a.939.939 0 0 0 1.327 1.327l2.62-2.617 1.68 1.682a.939.939 0 0 0 1.328 0l3.75-3.75-.003-.003Z"
      />
    </Svg>
  );
};

export default GraphIcon;
